<template>
  <div>
    <autocomplete
      v-model="model"
      :loading="loading"
      :items="computedItems"
      item-text="itemLabel"
      return-object
      :label="placeholder ? '' : label || $t('code') + $t('of_article')"
      :placeholder="placeholder"
      :hide-details="hideDetails"
      :rules="rules"
      :color="color"
      :hint="hint"
      :persistent-hint="persistentHint"
      show-item-slot
      :required="required"
      show-selection-slot
      :filter="customFilter"
      prepend-item
      @enter="itemSelected"
      @update:search-input="search = $event"
    >
      <template v-slot:prepend-item v-if="!disableAdd">
        <v-list-item @click="openAddDialog">
          <v-list-item-title>
            <v-icon color="primary">mdi-plus-circle</v-icon>
            <strong class="ml-2">{{ $t("add_grocery") }}</strong>
          </v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
      </template>
      <template v-slot:item="{ item }">
        <div>
          <small v-if="item.code">{{ item.code }}</small>
          <small v-else class="grey--text font-italic">{{ $t('no_code') }}</small>
          <span class="mx-1">-</span>
          <span class="grey--text">{{ toLatin(item.name) }}</span>
        </div>
      </template>
      <template v-slot:selection="{ data }">
        <div>
          <small v-if="data.item.code">{{ data.item.code }}</small>
          <small v-else class="grey--text font-italic">{{ $t('no_code') }}</small>
          <span class="mx-1">-</span>
          <span class="grey--text">{{ toLatin(data.item.name) }}</span>
        </div>
      </template>
    </autocomplete>
    <slot name="label"></slot>

    <grocery-dialog
      v-model="groceryDialog"
      :edited-item="newGrocery"
      @groceryCreated="handleGroceryCreated"
      @groceryUpdated="handleGroceryUpdated"
    />
  </div>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import GroceryDialog from "@/components/groceries/dialogs/GroceryDialog.vue";
import { defaultGrocery } from "@/models/food";

export default {
  mixins: [hasModel],
  components: {
    GroceryDialog,
  },
  props: {
    groceries: {
      type: Array,
      required: true,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: "default",
    },
    disableAdd: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: "",
    },
    persistentHint: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
    search: null,
    groceryDialog: false,
    newGrocery: {},
  }),
  computed: {
    computedItems() {
      return this.groceries.map((item) => ({
        ...item,
        itemLabel: item.code || item.name || "",
      }));
    },
  },
  methods: {
    customFilter(item, queryText) {
      // Filter items by code or name
      const searchLower = (queryText || "").toLowerCase();
      const code = (item.code || "").toLowerCase();
      const name = (item.name || "").toLowerCase();

      return code.includes(searchLower) || name.includes(searchLower);
    },
    itemSelected(grocery) {
      const toEmit = this.model || grocery;
      this.$emit("enter", toEmit);
    },
    openAddDialog() {
      this.newGrocery = { ...defaultGrocery, name: this.search || "" };
      this.groceryDialog = true;
    },
    handleGroceryCreated(grocery) {
      this.model = grocery;
      setTimeout(() => {
        this.$emit("groceryCreated", grocery);
        this.$emit("enter", grocery);
        this.groceryDialog = false;
      }, 100);
      // Auto-select the newly created item
    },
    handleGroceryUpdated(grocery) {
      this.$emit("groceryUpdated", grocery);
      this.groceryDialog = false;
    },
  },
};
</script>
